"use strict";

export function init() {
    let $baseElement = $('.js-webcam-preview');
    if ($baseElement.length > 0) {
        let $btn = $baseElement.find('.js-webcam-preview__btn');
        let $playText = $btn.find('.js-webcam-preview__btn-play');
        let $pauseText = $btn.find('.js-webcam-preview__btn-pause');
        let $posterImgs = $baseElement.find('.js-webcam-preview__poster-img');

        $btn.on('click', function() {
            $posterImgs.each(function() {
                let $posterImg = $(this);

                if ($posterImg.hasClass('d-block')) {
                    $posterImg.removeClass('d-block');
                    $pauseText.addClass('d-none');
                    $playText.removeClass('d-none');
                }
                else {
                    $posterImg.addClass('d-block');
                    $pauseText.removeClass('d-none');
                    $playText.addClass('d-none');
                }
            });
        });
    }
}